import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { getIconColorSVGFill } from '../../tools/colors.js';
import css_248z from './icons.styles.css.js';

let ChevronLeftIcon = class ChevronLeftIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'iconNeutralSoft';
        this.size = '24';
    }
    render() {
        return html `
      <svg
        width=${`${this.size}px`}
        height=${`${this.size}px`}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="transform: rotate(270deg);"
      >
        <path
          d="M11.2951 9.00002L6.7051 13.59C6.3151 13.98 6.3151 14.61 6.7051 15C7.0951 15.39 7.7251 15.39 8.1151 15L12.0051 11.12L15.8851 15C16.2751 15.39 16.9051 15.39 17.2951 15C17.6851 14.61 17.6851 13.98 17.2951 13.59L12.7051 9.00002C12.3251 8.61002 11.6851 8.61002 11.2951 9.00002Z"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
      </svg>
    `;
    }
};
ChevronLeftIcon.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], ChevronLeftIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], ChevronLeftIcon.prototype, "size", void 0);
ChevronLeftIcon = __decorate([
    customElement('chevron-left-icon')
], ChevronLeftIcon);
var ChevronLeftIcon$1 = ChevronLeftIcon;

export { ChevronLeftIcon$1 as default };
//# sourceMappingURL=chevronLeftIcon.js.map
